export const smoothScrollUpdate = () => document.dispatchEvent(new CustomEvent('smoothScrollUpdate'))
